module.exports = __webpack_public_path__ + "static/img/bag2.d99d1f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bag2.jpg
// module id = by+B
// module chunks = 1